import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, DoCheck,
  Input, OnInit,
  Optional, Self,
  ViewEncapsulation
} from '@angular/core';
import {RadioGroupInputValue} from '../../models/radioGroupInputValue';
import {ControlValueAccessor, NgControl} from '@angular/forms';
import {MessageService} from '../../services/message-service.service';

@Component({
  selector: 'app-radio-group-form',
  templateUrl: './radio-group-form.component.html',
  styleUrls: ['./radio-group-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class RadioGroupFormComponent implements ControlValueAccessor, OnInit, DoCheck {

  @Input() public buttonValues: RadioGroupInputValue[];
  @Input() public label?: string;
  @Input() public inputHint?: string;
  @Input() public hintIconExist?: boolean;
  @Input() public errorMessage?: string;
  @Input() public testId?: string;
  @Input() public warningMessage?: string;
  @Input() public isWarningVisible?: boolean;
  @Input() public isRequired?: boolean;
  @Input() private defaultSelectedIndex?: number;
  @Input() public isLabelInColumn = true;
  public isDisabled: boolean;
  private oldTouched = null;

  onChange: any = (event) => {
    this.ctrl?.control.setValue(event);
  };
  onTouched: any = () => {};

  constructor(@Self() @Optional() public ctrl: NgControl,
              private cd: ChangeDetectorRef, private messageService: MessageService) {
    if (this.ctrl) {
      this.ctrl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (
      typeof this.ctrl.value !== 'boolean' &&
      typeof this.defaultSelectedIndex === 'number' &&
      this.buttonValues?.length
    ) {
      this.selectItem(this.buttonValues[this.defaultSelectedIndex].code);
    }
  }

  ngDoCheck() {
    if (this.ctrl.touched !== this.oldTouched) {
      this.oldTouched = this.ctrl.touched;
    }
    this.cd.markForCheck();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {}

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  selectItem(value) {
    if (!this.isDisabled) {
      this.ctrl?.control.setValue(value);
    }
  }

  setDisabledState?(disabled: boolean) {
    this.isDisabled = disabled;
  }

  public getErrorMessage(): string {
    if (!this.errorMessage) {
      if (this.ctrl?.invalid) {
        return this.messageService.getControlErrorMessage(this.ctrl.errors);
      }  return null;
    }
    return this.errorMessage;
  }
}
